<template>
  <div class="auth">
    <div class="auth-container">
      <div class="card">
        <header class="auth-header">
          <h1 class="auth-title">
            <img src="/static/logo-login.png" alt="Volta Analytics">
          </h1>
        </header>
        <div class="auth-content">
          <form v-if="! isExpired" id="login-form" v-on:submit.prevent="send">
            <div class="form-group mb-0">
              <input type="password" v-model="password" class="form-control no-border" id="password" placeholder="Password" required> </div>
            <div class="form-group">
              <input type="password" v-model="password2" class="form-control no-border" id="password2" placeholder="Ripeti la password" required> </div>

            <p class="alert alert-warning" v-if="message">
              {{ message }}
            </p>
            
            <p class="alert alert-danger" v-if="fail">
              Sessione scaduta, torna alla <router-link to="/login">login</router-link>
            </p>
            <p class="alert alert-success" v-if="success">
              Password aggiornata, torna alla <router-link to="/login">login</router-link>
            </p>

            <div class="form-group">
              <button type="submit" class="btn btn-block btn-primary">
                <font-awesome-icon class="fa-spin" icon="spinner" v-if="loading" />
                <span v-if="!loading">Reset password</span>
              </button>
            </div>
          </form>
          <p v-else class="alert alert-warning">Link non valido o scaduto</p>
          <div>
            <router-link to="/login">Torna alla login</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import moment from 'moment';

export default {
  name: 'PasswordReset',
  data() {
    return {
      password: "",
      password2: "",
      fail: false,
      success: false,
      message: "",
      isExpired: false,
    }
  },
  computed: {
    loading() {
      return this.$store.state.pending
    }
  },
  created() {
    this.$store.commit("loading");
    this.$store.dispatch("users/checkTokenResetPassword", {
      token: this.$route.query.token,
      date: moment()
    }).then(res => {
      if(! res.data) {
        this.isExpired = true;
      } 
      this.$store.commit("stopLoading");
    })
  },
  methods: {
    validate() {
      if(this.password.length < 5) {
        this.message = "Inserire una password di almeno 5 caratteri";
        return false;
      }

      if(this.password != this.password2) {
        this.message = "Le password non corrispondono";
        return false;
      }

      this.message = "";
      return true;
    },
    send() {
      if(! this.validate())
        return;

      this.$store.commit("loading");
      this.$store.dispatch("users/setPassword", {
        token: this.$route.query.token,
        password: this.password
      }).then(res => {
        this.$store.commit("stopLoading");
        if(res.data.code == 1) {
          this.success = true;
        } else {
          this.fail = true;
        }
      })
    }
  },
}
</script>

<style scoped>
.alert-danger a,
.alert-success a {
  color: #fff;
}
.logo img {
  height: 30px;
}
.auth {
  background: url('/static/bg.jpg') center center;
  background-size: cover;
}
.auth-title img {
  width: 300px;
}
.card {
  background: transparent;
  -webkit-box-shadow:none;
  box-shadow: none;
}
.card input[type=password] {
  background: transparent;
  color:#fff;
}
.form-control.no-border {
  border:0;
}
#password {
  border: 1px solid #fff;
  border-bottom:0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
#password2 {
  border: 1px solid #fff;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordReset.vue